import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { ReactivateSubscriptionComponent } from './subscription.reactivate.component';
import { SharedModule }                    from '../shared/shared.module';
import { SubscriptionService }             from './subscription.service';

@NgModule({
  declarations: [
    ReactivateSubscriptionComponent
  ],
  entryComponents: [
    ReactivateSubscriptionComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    SubscriptionService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class SubscriptionsModule {}
